var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33594 8.05551C6.33594 7.46606 6.57009 6.90076 6.98689 6.48396C7.40369 6.06716 7.96899 5.83301 8.55844 5.83301H15.7801C16.072 5.83301 16.361 5.89049 16.6306 6.00219C16.9003 6.11388 17.1453 6.27758 17.3517 6.48396C17.558 6.69034 17.7217 6.93535 17.8334 7.20499C17.9451 7.47464 18.0026 7.76365 18.0026 8.05551V15.2772C18.0026 15.569 17.9451 15.858 17.8334 16.1277C17.7217 16.3973 17.558 16.6423 17.3517 16.8487C17.1453 17.0551 16.9003 17.2188 16.6306 17.3305C16.361 17.4422 16.072 17.4997 15.7801 17.4997H8.55844C8.26657 17.4997 7.97757 17.4422 7.70792 17.3305C7.43828 17.2188 7.19327 17.0551 6.98689 16.8487C6.78051 16.6423 6.61681 16.3973 6.50512 16.1277C6.39342 15.858 6.33594 15.569 6.33594 15.2772V8.05551Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.84333 13.9475C3.58779 13.8018 3.37523 13.5912 3.22715 13.3371C3.07906 13.0829 3.00071 12.7942 3 12.5V4.16667C3 3.25 3.75 2.5 4.66667 2.5H13C13.625 2.5 13.965 2.82083 14.25 3.33333",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyDark);
export default __webpack_public_path__ + "static/media/copyDark.b67ba801fb78ea0554e58449e6eacc56.svg";
export { ForwardRef as ReactComponent };